var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Linkify from 'linkifyjs/react';
import linkOptions from '../../../utils/link-options';
var CardSystem = (function (_super) {
    __extends(CardSystem, _super);
    function CardSystem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentTime = new Date().getTime();
        return _this;
    }
    CardSystem.prototype.getLinkifyContent = function () {
        var _a = this.props, templateData = _a.templateData, reUpdateInputMessage = _a.reUpdateInputMessage, locale = _a.locale;
        var txt = templateData.txt, recallContent = templateData.recallContent, warnTitle = templateData.warnTitle;
        var recallContentObject = recallContent && JSON.parse(recallContent) || '';
        var _b = recallContentObject.oldMsgTxt, oldMsgTxt = _b === void 0 ? '' : _b, _c = recallContentObject.editEndTime, editEndTime = _c === void 0 ? '' : _c;
        return recallContentObject ? (React.createElement("span", null,
            oldMsgTxt && editEndTime !== undefined
                ? locale.selfrecall || "Message recalled"
                : locale.senderrecall || "Sender recalled the message",
            this.currentTime < editEndTime && oldMsgTxt && (React.createElement("a", { onClick: function () { return reUpdateInputMessage(oldMsgTxt); }, className: "reEdit" }, locale.reedit || "Edit")))) : warnTitle ? (React.createElement("div", { className: "warn-card" },
            React.createElement("div", { className: "warn-title" },
                React.createElement("hr", null),
                warnTitle,
                React.createElement("hr", null)),
            txt)) : (txt);
    };
    CardSystem.prototype.render = function () {
        return React.createElement(Linkify, { tagName: "div", className: "lzd-system-text", options: linkOptions }, this.getLinkifyContent());
    };
    CardSystem.STYLE = 'system';
    return CardSystem;
}(React.Component));
export default CardSystem;

//# sourceMappingURL=index.js.map
